"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_MAPPING_CHANGED = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigSection_1 = tslib_1.__importDefault(require("../../configurationControls/ConfigSection"));
var ColoredItemsList_1 = tslib_1.__importDefault(require("./coloredItemsList/ColoredItemsList"));
var translations_1 = require("../../../utils/translations");
var colors_1 = require("../../../utils/colors");
exports.COLOR_MAPPING_CHANGED = "COLOR_MAPPING_CHANGED";
var ColorsSection = /** @class */ (function (_super) {
    tslib_1.__extends(ColorsSection, _super);
    function ColorsSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelect = function (selectedColorItem, color) {
            var _a = _this.props, properties = _a.properties, pushData = _a.pushData;
            var mappingHeader = selectedColorItem.mappingHeader;
            var result = colors_1.getProperties(properties, mappingHeader, color);
            var message = {
                messageId: exports.COLOR_MAPPING_CHANGED,
                properties: result,
            };
            pushData(message);
        };
        _this.onResetColors = function () {
            var _a = _this.props, properties = _a.properties, pushData = _a.pushData;
            if (_this.isDefaultColorMapping()) {
                return;
            }
            var propertiesWithoutColorMapping = set_1.default(cloneDeep_1.default(properties), "controls.colorMapping", undefined);
            var message = {
                messageId: exports.COLOR_MAPPING_CHANGED,
                properties: propertiesWithoutColorMapping,
                references: {},
            };
            pushData(message);
        };
        return _this;
    }
    ColorsSection.prototype.render = function () {
        var _a = this.props, pushData = _a.pushData, propertiesMeta = _a.propertiesMeta;
        return (react_1.default.createElement(ConfigSection_1.default, { title: "properties.colors", pushData: pushData, propertiesMeta: propertiesMeta, id: "colors_section", className: "adi-color-configuration" }, this.renderSectionContents()));
    };
    ColorsSection.prototype.isColoredListVisible = function () {
        var _a = this.props, colors = _a.colors, hasMeasures = _a.hasMeasures, controlsDisabled = _a.controlsDisabled, isLoading = _a.isLoading;
        return isLoading || (!controlsDisabled && colors && colors.colorPalette && hasMeasures);
    };
    ColorsSection.prototype.renderResetButton = function () {
        var controlsDisabled = this.props.controlsDisabled;
        var isDisabled = controlsDisabled || this.isDefaultColorMapping();
        var classes = classnames_1.default("gd-color-reset-colors-section", {
            disabled: isDisabled,
        });
        return (react_1.default.createElement("div", { className: classes },
            react_1.default.createElement(sdk_ui_kit_1.Button, { value: translations_1.getTranslation("properties.colors.reset-colors", this.props.intl), className: "gd-button-link s-reset-colors-button", onClick: this.onResetColors, disabled: isDisabled })));
    };
    ColorsSection.prototype.renderColoredList = function () {
        var _a = this.props, colors = _a.colors, showCustomPicker = _a.showCustomPicker, controlsDisabled = _a.controlsDisabled, isLoading = _a.isLoading;
        var inputItems = colors_1.getColoredInputItems(colors);
        var colorPalette = colors && colors.colorPalette ? colors.colorPalette : [];
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(ColoredItemsList_1.default, { colorPalette: colorPalette, inputItems: inputItems, onSelect: this.onSelect, showCustomPicker: showCustomPicker, disabled: controlsDisabled, isLoading: isLoading }),
            this.renderResetButton()));
    };
    ColorsSection.prototype.isDefaultColorMapping = function () {
        var _a, _b;
        var properties = this.props.properties;
        var colorMapping = (_b = (_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a.colorMapping) !== null && _b !== void 0 ? _b : [];
        return !colorMapping || colorMapping.length === 0;
    };
    ColorsSection.prototype.renderUnsupportedColoredList = function () {
        return (react_1.default.createElement("div", { className: "gd-color-unsupported" }, translations_1.getTranslation("properties.colors.unsupported", this.props.intl)));
    };
    ColorsSection.prototype.renderSectionContents = function () {
        return this.isColoredListVisible() ? this.renderColoredList() : this.renderUnsupportedColoredList();
    };
    return ColorsSection;
}(react_1.default.Component));
exports.default = react_intl_1.injectIntl(ColorsSection);
//# sourceMappingURL=ColorsSection.js.map